<template>
  <div class="col col-lg-12 px-lg-12 py-lg-12">
    <div
      class="row">
      <div class="col-lg-12 px-lg-12 py-lg-12">
        <h6>Stai applicando questi filtri:</h6>
        <div
          class="container years-filter-containers"
          v-if="pronunceFilters.years && pronunceFilters.years.length"
        >
          <div
            class="chip anno-bg"
            v-for="(year, $index) in pronunceFilters.years" :key="`y${$index}`">
              <span class="chip-label text-white"><em>anno</em>: {{year}}</span>
              <button @click="deleteFilter('years', $indexY)">
                <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
                <span class="sr-only">Elimina filtro</span>
              </button>
          </div>
        </div>
        <div
          class="chip presidente-bg"
          v-for="(presidente, $index) in pronunceFilters.presidents" :key="`p${$index}`">
            <span class="chip-label text-white"><em>presidente</em>: {{presidente}}</span>
            <button @click="deleteFilter('presidents', $index)">
              <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
              <span class="sr-only">Elimina filtro</span>
            </button>
        </div>
        <div
          class="chip relatore-bg"
          v-for="(relatore, $index) in pronunceFilters.relators" :key="`r${$index}`">
          <span class="chip-label text-white"><em>relatore</em>: {{relatore}}</span>
            <button @click="deleteFilter('relators', $index)">
              <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
              <span class="sr-only">Elimina filtro</span>
            </button>
        </div>
        <div
          class="chip giudice-bg"
          v-for="(giudice, $index) in pronunceFilters.judges" :key="`j${$index}`">
            <span class="chip-label text-white"><em>giudice</em>: {{giudice}}</span>
            <button @click="deleteFilter('judges', $index)">
              <svg class="icon white"><use :xlink:href="icons.itClose"></use></svg>
              <span class="sr-only">Elimina filtro</span>
            </button>
        </div>
      </div>
    </div>
    <div class="row">
      <button
        class="btn btn-outline-primary btn-lg my-4 float-right btn-block"
        type="button"
        @click="deleteAllFilters()">Cancella tutti i filtri</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'filters',
  computed: mapState(['pronunceFilters']),
  methods: {
    deleteAllFilters() {
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER').then(() => {
        this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(() => {
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentSentenze,
            size: this.documentsSetsSize,
            type: 'sentenza',
          });
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentOrdinanze,
            size: this.documentsSetsSize,
            type: 'ordinanza',
          });
        });
      });
    },
    deleteFilter(type, index) {
      this.$store.dispatch('EMPTY_PRONUNCE_FILTER', {
        type,
        index,
      }).then(() => {
        this.$store.dispatch('EMPTY_DOCUMENTS_LIST').then(() => {
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentSentenze,
            size: this.documentsSetsSize,
            type: 'sentenza',
          });
          this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
            start: this.documentsSetsStartFromDocumentOrdinanze,
            size: this.documentsSetsSize,
            type: 'ordinanza',
          });
        });
      });
    },
  },
  data() {
    return {
      icons: {
        itClose: `${sprites}#it-close`,
      },
    };
  },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/layout/accessory/Filters.vue